import React from 'react';
import PropTypes from 'prop-types';
import UniFormgenInputText from './UniFormgenInputText';
import UniFormgenTextarea from './UniFormgenTextarea';
import UniFormgenInputPassword from './UniFormgenInputPassword';
import UniFormgenInputEmail from './UniFormgenInputEmail';
import UniFormgenInputNumber from './UniFormgenInputNumber';
import UniFormgenInputCheckbox from './UniFormgenInputCheckbox';
import UniFormgenSelect from './UniFormgenSelect';
import UniFormgenRadioGroup from './UniFormgenRadioGroup';
import UniFormgenSpecialFieldDisplayValue from './UniFormgenSpecialFieldDisplayValue';
import UniFormgenSpecialFieldDisplayFakeValue from './UniFormgenSpecialFieldDisplayFakeValue';
import UniFormgenSpecialStars5 from './UniFormgenSpecialStars5';
import UniBr from './UniBr';
import UniFormcompoSeparator from './UniFormcompoSeparator';
import UniEmptySpace from './UniEmptySpace'; //
import UniFormgenHtmlTagText from './UniFormgenHtmlTagText';
import UniFormgenSpecialTagsCsv from './UniFormgenSpecialTagsCsv';
import { js_utils } from '../utils/frfr-js-utils';
// import { reusableJqueryMoveFocus } from '../hooks/reusableJqueryMoveFocus';


/*
FormGenerator

*/

//
const _form_generator_types_obj = {
  "br": {
    no_props: true,
  },
  "separator": {
  },
  "empty_space": {
  },
  "row": {
    def_with_children: true,
  },
  "wrapper": {
    def_with_children: true,
  },
  "html_tag_text": {
  },
  "input_text": {
    is_input: true,
  },
  "input_password": {
    is_input: true,
  },
  "input_email": {
    is_input: true,
  },
  "field_display_value": {
  },
  "field_display_fake_value": {
  },
  "textarea": {
    is_input: true,
  },
  "input_number": {
    is_input: true,
  },
  "input_checkbox": {
    is_input: true,
  },
  "select": {
    is_input: true,
  },
  "input_radio_group": {
    is_input: true,
  },
  "widget_stars5": {
    is_input: true,
  },
  "injected_element": {
  },
  //
  "novo_paper": { // TODO
    extraClass_in_params: false,
  },
  "widget_tags_csv": {
    is_input: true,
  },
  //
};


//
const _prepare_type_features = (form_def_item) => {
  if (form_def_item && typeof form_def_item.type === 'string') {
    const fdi_type = form_def_item.type;
    if (_form_generator_types_obj[fdi_type]) {
      const type_features = _form_generator_types_obj[fdi_type];
      let extraClass_in_params = true;
      if (type_features.extraClass_in_params === false) { // TODO
        extraClass_in_params = false;
      }
      return {
        ..._form_generator_types_obj[fdi_type],
        extraClass_in_params,
      };
    }
  }
  // else
  return {
    error: true,
    errors: {
      error_features_not_found: true,
    },
  };
};




// DEFAULT COMPONENT
const FormGenerator = (props) => {
  /*
  useEffect(() => {
    // svaki put
    // ovde cemo pozvati kod za menjanje fokusa na formama ako zatreba
    // console.log('* effect');
    // reusableJqueryMoveFocus();
  });
  */

  let arr = [];
  if (props.formDefinition) {
    if (Array.isArray(props.formDefinition)) {
      arr = props.formDefinition;
    } else if (typeof props.formDefinition === 'function') {
      const _formDefinition = props.formDefinition();
      console.log('props.formDefinition is FUNCTION...', _formDefinition);
      if (Array.isArray(_formDefinition)) {
        arr = _formDefinition;
      }
    }
  }

  let handleChange;
  if (typeof props.handleChange === 'function') {
    handleChange = props.handleChange;
  } else {
    handleChange = () => { };
  }

  let state = props.formState; // state koji sadrzi values od input polja
  let errors = {}; // state koji sadrzi greske za polja koje kreira validator forme
  if (js_utils.is_object(props.formErrors)) {
    errors = props.formErrors; // state koji sadrzi greske za polja koje kreira validator forme
  }
  let fakeState = {}; // specijalni lazni state za polja koja se samo prikazuju
  if (props.fakeState) {
    fakeState = props.fakeState;
  }

  let make_form_elements = (arr) => {
    let jsx_form_arr = arr.map((form_def_item, index) => {

      if (form_def_item && typeof form_def_item.type === 'string') {
        const fdi_type = form_def_item.type;
        if (fdi_type === "br") {
          return (
            <UniBr key={index} />
          );
          /*
        } else if (fdi_type === "break") {
          return (
            <UniBr key={index} />
          );
        */
        } else if (fdi_type === "separator") {
          return (
            <UniFormcompoSeparator key={index} size={form_def_item?.params?.size} />
          );
        } else if (fdi_type === "empty_space") {
          // NO props.params
          return (
            <UniEmptySpace key={index} w={form_def_item?.params?.w} h={form_def_item?.params?.h} extraClass={form_def_item?.params?.extraclass} />
          );
        } else if (fdi_type === "row") {
          return make_form_row(form_def_item.params, index);
        } else if (fdi_type === "wrapper") {
          return make_form_group(form_def_item.params, index);
        } else if (fdi_type === "html_tag_text") { // TODO single HTML tag with text
          return (
            <UniFormgenHtmlTagText key={index} params={form_def_item.params} />
          );
        } else if (fdi_type === "input_text") {
          return (
            <UniFormgenInputText
              key={index}
              params={form_def_item.params}
              formState={state}
              formErrors={errors}
              handleChange={handleChange}
            />
          );
        } else if (fdi_type === "input_password") {
          return (
            <UniFormgenInputPassword
              key={index}
              params={form_def_item.params}
              formState={state}
              formErrors={errors}
              handleChange={handleChange}
            />
          );
        } else if (fdi_type === "input_email") {
          return (
            <UniFormgenInputEmail
              key={index}
              params={form_def_item.params}
              formState={state}
              formErrors={errors}
              handleChange={handleChange}
            />
          );
        } else if (fdi_type === "field_display_value") { // istaknuto display (read-only) polje
          return (
            <UniFormgenSpecialFieldDisplayValue
              key={index}
              params={form_def_item.params}
              formState={state}
              formErrors={errors}
            />
          );
        } else if (fdi_type === "field_display_fake_value") {
          return (
            <UniFormgenSpecialFieldDisplayFakeValue
              key={index}
              params={form_def_item.params}
              fakeState={fakeState}
            />
          );
        } else if (fdi_type === "textarea") {
          return (
            <UniFormgenTextarea
              key={index}
              params={form_def_item.params}
              formState={state}
              formErrors={errors}
              handleChange={handleChange}
            />
          );
        } else if (fdi_type === "input_number") {
          return (
            <UniFormgenInputNumber
              key={index}
              params={form_def_item.params}
              formState={state}
              formErrors={errors}
              handleChange={handleChange}
            />
          );
        } else if (fdi_type === "input_checkbox") {
          return (
            <UniFormgenInputCheckbox
              key={index}
              params={form_def_item.params}
              formState={state}
              formErrors={errors}
              handleChange={handleChange}
            />
          );
        } else if (fdi_type === "select") {
          return (
            <UniFormgenSelect
              key={index}
              params={form_def_item.params}
              formState={state}
              formErrors={errors}
              handleChange={handleChange}
            />
          );
        } else if (fdi_type === "input_radio_group") {
          return (
            <UniFormgenRadioGroup
              key={index}
              params={form_def_item.params}
              formState={state}
              formErrors={errors}
              handleChange={handleChange}
            />
          );
        } else if (fdi_type === "widget_stars5") {
          return (
            <UniFormgenSpecialStars5
              key={index}
              params={form_def_item.params}
              formState={state}
              formErrors={errors}
              handleChange={handleChange}
            />
          );
        } else if (fdi_type === "widget_tags_csv") {
          return (
            <UniFormgenSpecialTagsCsv
              key={index}
              params={form_def_item.params}
              formState={state}
              formErrors={errors}
              handleChange={handleChange}
            />
          );
        } else if (fdi_type === "injected_element") {
          let jsxInjected = null;
          let style = {};
          if (form_def_item.params) {
            // PRIORITY IS key_of_injected_elements_obj
            if (form_def_item.params.key_of_injected_elements_obj) { // CASE 1) obj key
              let key_of_injected = false;
              if (form_def_item.params.key_of_injected_elements_obj) {
                key_of_injected = form_def_item.params.key_of_injected_elements_obj;
                if (props.injectedElementsObj && props.injectedElementsObj[key_of_injected]) {
                  jsxInjected = props.injectedElementsObj[key_of_injected];
                }
              }
            } else { // CASE 2) arr index
              let index_of_injected = -1;
              if (form_def_item.params.index_of_injected_elements_arr === 0 || form_def_item.params.index_of_injected_elements_arr > 0) {
                index_of_injected = form_def_item.params.index_of_injected_elements_arr;
                if (Array.isArray(props.injectedElementsArr) && props.injectedElementsArr[index_of_injected]) {
                  jsxInjected = props.injectedElementsArr[index_of_injected];
                }
              }
            }
            // add style
            if (form_def_item.params.w > 0) {
              style = {
                width: form_def_item.params.w
              };
            }
          }
          /*
          if (Array.isArray(props.injectedElementsArr) && props.injectedElementsArr.length > 0) {
            if (form_def_item.params && (form_def_item.params.index_of_injected_elements_arr === 0 || form_def_item.params.index_of_injected_elements_arr > 0) && props.injectedElementsArr[form_def_item.params.index_of_injected_elements_arr]) {
            }
          }
          */
          return (
            <div className="uniformcompo__field uniformcompo__field--flex-start" key={index} style={style}>
              {jsxInjected}
            </div>
          );
        } else {
          /*
          return (
            <>
            </>
          );
          */
          return null;
        }
      } else {
        return null;
      }

    });
    return jsx_form_arr;
  };


  let make_form_row = (row_params, index) => {
    let jsx_row_elements = make_form_elements(row_params.children);
    let cl = 'IZMENIME';
    if (typeof row_params.extraclass === 'string') {
      cl = row_params.extraclass;
    }
    let jsx_form_row = (
      <div key={index} className={"uu-form-vector-row " + cl}>
        {jsx_row_elements}
      </div>
    );
    return jsx_form_row;
  };

  let make_form_group = (row_params, index) => {
    let jsx_row_elements = make_form_elements(row_params.children);
    let cl = 'IZMENIME';
    if (typeof row_params.extraclass === 'string') {
      cl = row_params.extraclass;
    }
    let jsx_form_row = (
      <div key={index} className={"uniformcompo__wrapper " + cl}>
        {jsx_row_elements}
      </div>
    );
    return jsx_form_row;
  };

  let jsx_form_content = make_form_elements(arr);

  let cl_validation_errors = '';
  if (js_utils.is_object(errors) && Object.keys(errors).length > 0) {
    cl_validation_errors = ' validation-errors';
  }

  let cl_extra = '';
  if (typeof props.extraClass === 'string') {
    cl_extra = ' ' + props.extraClass;
  }

  return (
    <div className={"frfr-form-generator-widget" + cl_validation_errors + cl_extra}>
      <div className="frfr-form-generator-widget__output-container">
        {jsx_form_content}
      </div>
    </div>
  );
};

FormGenerator.propTypes = {
  // formDefinition: PropTypes.array,
  formState: PropTypes.object,
  formErrors: PropTypes.object,
  handleChange: PropTypes.func
};

export default FormGenerator;